import React, { useEffect, useState } from "react";
import Layout from "../../../components/biblio/Layout";
import Nav from "../../../components/biblio/missions/Nav";
import SubNavMission from "../../../components/biblio/missions/SubNavMission";
import { Pencil, Save, Trash } from "../../../components/Icons";
import Modal from "../../../components/Modal";
import { USER_ROLES } from "../../../helpers/Constants";
import { notify } from "../../../helpers/Helper";
import MissionStore from "../../../store/MissionStore";
import UserStore from "../../../store/UserStore";

const Form = ({ profil, reset, close }) => {

   const [current, setCurrent] = useState(profil);

   const handleChange = (e) => {
      setCurrent({ ...current, [e.target.name]: e.target.value })
   }

   const handleSubmit = (e) => {
      e.preventDefault();
      MissionStore.saveProfil(current).then(_ => {
         notify("Succès", "Le profil a été enregistré.", "success");
         setCurrent(reset);
         e.target.reset();
         close()
      })
   }

   return (
      <form onSubmit={handleSubmit}>

         <div className="mb-3">
            <div className="form-group">
               <span>Libellé <small className="fw-bold">[obligatoire]</small></span>
               <input type="text" name="libelle" className="form-control" value={current.libelle} onChange={handleChange} required />
            </div>
         </div>
      
         <button type="submit" style={{ width: '100%' }} className="btn btn-warning mx-auto d-block"><Save /> Enregister</button>
      </form>
   );
}

export default function Profils() {

   const [profils, setProfils] = useState([]);
   const [profil, setProfil] = useState({ libelle: "", libUnique: "" });
   const [showModal, setShowModal] = useState(false);
   const [loading, setLoaging] = useState(false);

   useEffect(() => {
      if (!UserStore.hasRole(USER_ROLES.ROLE_GESTIONS_MISSION) && !UserStore.hasRole(USER_ROLES.ROLE_RESPONSABLE_ORGANE ) && !UserStore.hasRole(USER_ROLES.ROLE_SUPERVISEUR )){
         window.location.href = "/bibliotheque";
      }
      init();
   }, [])

   const init = async () => {
      setLoaging(true)
      const { data } = await MissionStore.getProfils();
      setProfils(data);
      setLoaging(false)
   }

   const removeProfil = (id) => {
      if (window.confirm("Supprimer ce profil?"))
         MissionStore.removeProfil(id).then(_ => init())
   }

   const updateProfil = (profil) => {
      setProfil(profil);
      setShowModal(true);
   }

   const newProfil = (e) => {
      e.preventDefault();
      setProfil({});
      setShowModal(true);
   }

   const onModalClose = () => {
      init();
      setProfil({ libelle: "" })
      setShowModal(false);
   }

   const Body = () => {
      return (
         <>
            <Nav />
            <SubNavMission/>
            <div className="p-1 breadcrumbs xs-font mt-5 pt-4 pb-4">
               <a href="/bibliotheque" className="textPrimary fw-bold">Accueil</a> <span>/ Profils missions</span>
            </div>
            <h4 className="page-title">Les profils de missions</h4>
            <button onClick={newProfil} className="btn btn-primary" style={{ float: "right", marginRight: "30px" }}>Créer un profil de mission</button>
            <div className="container-fluid mt-4 mb-5">
               <div className="card p-3">
                  <table className={`table table-striped ${loading ? 'loading' : ''}`}>
                     <thead>
                        <tr>
                           <th>#</th>
                           <th>Libellé</th>
                        
                           <th className="text-center"></th>
                        </tr>
                     </thead>
                     <tbody>
                        {profils.map((profil, index) =>
                           <tr key={profil.id}>
                              <td>{index + 1}</td>
                              <td>{profil.libelle}</td>
                             
                              <td>
                                 <button type="button" className="btn btn-sm btn-success" style={{ marginRight: "20px" }} onClick={() => updateProfil(profil)} title="Modifier"><Pencil /></button>
                                 <button type="button" className="btn btn-sm btn-danger" onClick={() => removeProfil(profil.id)} title="Supprimer"><Trash /></button>
                              </td>
                           </tr>
                        )}

                     </tbody>
                  </table>
               </div>

            </div>
            <Modal size="" show={showModal} title="Enregistrer un profil de mission" body={<Form profil={profil} reset={{ libelle: "" }} close={onModalClose} />} onClose={onModalClose} />
         </>
      );
   }

   return <Layout body={<Body />} />
}